import { render } from "./ListLainnyaView.vue?vue&type=template&id=793b42d3"
import script from "./ListLainnyaView.vue?vue&type=script&lang=js"
export * from "./ListLainnyaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__